import { ApckVulnTable } from '../vulns/vulns-table';

export const ApckAssetView = {
    components: {
        'apck-vulntable': ApckVulnTable
    },
    props: {
        assetID: {
            type: String,
            default: "",
            required: true
        }
    },
    data: function() {
        let values = {
            os_logo: "/assets/images/cpe/o/microsoft/windows.png",
            os_version: "Windows XP Service Pack 3 2010",
            os_description: "Other description",

            title: "Testing View",

            first_detected_at: "01/01/2024",
            last_detected_at: "24/01/2024",

            priority_list: [],// DropdownField(name='priority', options=self.PRIORITY, selected='')
            risk: "Medium",
        };
        return values;
    },
    computed: {
        _title: function() {
            return `${this.title}`
        }
    },
    template: `
        <div>
            <apck-titlebar :title="_title">
                <template v-slot:actions>
                    <span class="asset-risk risk-medium">
                        Risk Level: {{ risk }}
                    </span>
                </template>
            </apck-titlebar>

            <div class="assets-panel">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col col-xs-6">
                            <apck-panel title="General Information">
                                <div class="row no-gutter">
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                        <div class="os_box">
                                            <img :src="os_logo" class="img-responsive">
                                            <div class="os_title">{{ os_version }}</div>
                                            <div class="os_description">{{ os_description }}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-10 col-xs-12">
                                        <div class="row no-gutter span-left">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <ul class="list-group">
                                                    <li class="list-group-item"><b>First seen:</b> {{ first_detected_at }}</li>
                                                    <li class="list-group-item"><b>Last seen:</b> {{ last_detected_at }}</li>
                                                </ul>
                                            </div>
                                            <div class="row no-gutter">
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div class="priority-list">
                                                        <h1>Priority</h1>
                                                        
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </apck-panel>

                            <apck-panel title="Detected Software">
                                <a class="asset-cpe" href="javascript:;">
                                    Google Chrome: 120.0.6099.216
                                </a>
                                <a class="asset-cpe" href="javascript:;">
                                    Docker CE: 23.0.6
                                </a>
                                <a class="asset-cpe" href="javascript:;">
                                    Nginx: 10.2
                                </a>
                                <a class="asset-cpe" href="javascript:;">
                                    Open SSH: 22.4
                                </a>
                            </apck-panel>

                            <apck-panel title="CVEs">
                                <a class="asset-cve high" href="javascript:;">
                                    <i class="fa fa-bug" />
                                    CVE-2022-19822
                                </a>
                                <a class="asset-cve medium" href="javascript:;">
                                    <i class="fa fa-bug" />
                                    CVE-2022-2234
                                </a>
                                <a class="asset-cve low" href="javascript:;">
                                    <i class="fa fa-bug" />
                                    CVE-2020-183
                                </a>
                                <a class="asset-cve medium" href="javascript:;">
                                    <i class="fa fa-bug" />
                                    CVE-2000-224
                                </a>
                                <a class="asset-cve low" href="javascript:;">
                                    <i class="fa fa-bug" />
                                    CVE-2023-69475
                                </a>
                            </apck-panel>
                        </div>
                        <div class="col col-xs-6">
                            <apck-panel title="Open Ports">
                                <span class="asset-port">
                                    80
                                </span>
                                <span class="asset-port">
                                    443
                                </span>
                                <span class="asset-port">
                                    8080
                                </span>
                                <span class="asset-port">
                                    8443
                                </span>
                                <span class="asset-port">
                                    5000
                                </span>
                                <span class="asset-port">
                                    65536
                                </span>
                            </apck-panel>

                            <apck-panel title="80 / TCP / Nginx">
                                <strong>Nginx</strong>
                                <pre>
HTTP/1.1 200 OK
Server: nginx
Date: Sun, 26 Nov 2023 15:00:24 GMT
Content-Type: text/html; charset=UTF-8
Content-Length: 28962
Connection: keep-alive
                                </pre>
                            </apck-panel>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-xs-6">
                            
                        </div>
                        <div class="col col-xs-6">
                        </div>
                    </div>
                </div>
            </div>


            <apck-vulntable
                :show-agent-filter="false"
                :show-critical-filter="true"
                :show-date-filters="false"
                :show-user-filter="false"
                :show-host-filter="false"
                />

        </div>
    `
}
